import React, { createContext, useContext, useState } from "react"
const MenuContext = createContext()

export const MenuProvider = ({ children }) => {
    const [menuOpen, setMenuOpen] = useState(false)
    const [searchOpen, setSearchOpen] = useState(false)
    const toggleMenu = () => {
        setMenuOpen(prev => !prev)
        setSearchOpen(false)
    }
    const toggleSearch = () => {
        setSearchOpen(prev => !prev)
        setMenuOpen(false)
    }
    return (
        <MenuContext.Provider value={{ menuOpen, searchOpen, toggleMenu, toggleSearch, setMenuOpen, setSearchOpen }}>
            {children}
        </MenuContext.Provider>
    )
}

export const useMenu = () => useContext(MenuContext)